import { graphql } from "../gql";

export const setClientSignOffClaimStatesMutationDoc = graphql(`
  mutation setClientSignOffClaimStates(
    $input: SetClientSignOffClaimStatesInput!
  ) {
    setClientSignOffClaimStates(input: $input) {
      clientSignOffClaimStates {
        batchClaim {
          batchClaimStateById {
            claimAuditType
            clientSignOffClaimState
            determinedAdjustedAllowedAmount
            determinedClientSavings
            determinedDiscrepantAmount
            disputedFindingClaimState
            documentationClaimState
            id
            invoiceClaimState
            isProviderActive
            isRealized
            negotiationClaimState
            onHoldClaimState
            potentialAdjustedAllowedAmount
            potentialClientSavings
            potentialDiscrepantAmount
            providerSignOffClaimState
            reported
            workflowClaimState
          }
          id
        }
      }
    }
  }
`);
